import { useEffect, useState } from 'react';

/**
 * 야간 응급 상담 시간 판정
 *  - 주말(토·일) 24시간
 *  - 평일 21:00 이후 또는 09:00 이전
 */
export function isEmergencyTime(date = new Date()) {
  const day = date.getDay();
  const hour = date.getHours();
  const isWeekend = day === 0 || day === 6;
  if (isWeekend) return true;
  return hour >= 21 || hour < 9;
}

function resolveMode(botMode) {
  // manual = 담당자 직접 응답 → 야간 응급 스타일 불필요, 일반 UI
  if (botMode === 'manual') return false;
  // auto = 시간대 기반 (야간/주말이면 LLM 자동)
  return isEmergencyTime();
}

async function fetchBotMode() {
  try {
    const res = await fetch('/chat/mode');
    if (!res.ok) return 'auto';
    const data = await res.json();
    return data.mode === 'manual' ? 'manual' : 'auto';
  } catch {
    return 'auto';
  }
}

export function useEmergencyMode() {
  const [emergency, setEmergency] = useState(() => resolveMode('auto'));

  useEffect(() => {
    let cancelled = false;

    const refresh = async () => {
      const botMode = await fetchBotMode();
      if (!cancelled) setEmergency(resolveMode(botMode));
    };

    refresh();
    // 15초마다 시간 재판정 + bot_mode 재확인
    const id = setInterval(refresh, 15_000);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return emergency;
}
